export default __webpack_public_path__ + "static/media/slider1.d7139f2a.png";